export function getHoraString(hora) {


    let horaSliced = hora.slice(0, -3);
    return horaSliced;
   
  }
  